import React from 'react';

const MinMaxContext = React.createContext({});
export default MinMaxContext;
